
    <dw-form-item-panel [dwFlex]="dwFlex"
                        [dwRequired]="dwRequired"
                        [dwFor]="dwFor"
                        [dwLabelOffset]="dwLabelOffset"
                        [dwLabelOrder]="dwLabelOrder"
                        [dwLabelPull]="dwLabelPull"
                        [dwLabelPush]="dwLabelPush"
                        [dwLabelSpan]="dwLabelSpan"
                        [dwLabelXs]="dwLabelXs"
                        [dwLabelSm]="dwLabelSm"
                        [dwLabelMd]="dwLabelMd"
                        [dwLabelLg]="dwLabelLg"
                        [dwLabelXl]="dwLabelXl"
                        [dwLabelXXl]="dwLabelXXl"
                        [dwHasFeedback]="dwHasFeedback"
                        [dwInputOffset]="dwInputOffset"
                        [dwInputOrder]="dwInputOrder"
                        [dwInputPull]="dwInputPull"
                        [dwInputPush]="dwInputPush"
                        [dwInputSpan]="dwInputSpan"
                        [dwInputXs]="dwInputXs"
                        [dwInputSm]="dwInputSm"
                        [dwInputMd]="dwInputMd"
                        [dwInputLg]="dwInputLg"
                        [dwInputXl]="dwInputXl"
                        [dwInputXXl]="dwInputXXl"
                        [validationMessages]="validationMessages"
                        [dwValidateStatus]="control"
                        [dwLabel]="dwLabel">

      <dw-select [(ngModel)]="dwValue" #dwSelect style="width: 100%;"
                 [compareWith]="compareWith"
                 [dwAllowClear]="dwAllowClear"
                 [dwOpen]="dwOpen"
                 (dwOpenChange)="dwOpenChange.emit()"
                 [dwAutoFocus]="dwAutoFocus"
                 [dwDisabled]="dwDisabled"
                 [dwDropdownClassName]="dwDropdownClassName"
                 [dwDropdownMatchSelectWidth]="dwDropdownMatchSelectWidth"
                 [dwDropdownStyle]="dwDropdownStyle"
                 [dwServerSearch]="dwServerSearch"
                 [dwFilterOption]="dwFilterOption"
                 [dwMaxMultipleCount]="dwMaxMultipleCount"
                 [dwMode]="dwMode"
                 [dwNotFoundContent]="dwNotFoundContent"
                 [dwPlaceHolder]="dwPlaceHolder"
                 [dwShowSearch]="dwShowSearch"
                 [dwSize]="dwSize"
                 (dwScrollToBottom)="dwScrollToBottom.emit()"
                 (dwOnSearch)="dwOnSearch.emit()">
        <ng-container *ngFor="let o of dwOptionList">
          <dw-option *ngIf="!dwIsLoading" [dwValue]="o.value" [dwLabel]="o.label" [dwDisabled]="o.disabled"></dw-option>
        </ng-container>
        <dw-option *ngIf="dwIsLoading" dwDisabled dwCustomContent>
          <i class="anticon anticon-loading anticon-spin loading-icon"></i>{{'dw-loadingData' | translate}}...
        </dw-option>
      </dw-select>
    </dw-form-item-panel>
  